import { css } from "styled-components";

export const scrollbarCSS = (alwaysShow?: boolean, size?: "large"|"default") => css`
    /* Firefox scrollbar styling */
    overflow: auto;
    scrollbar-width: ${ size=="large" ? "auto" : "thin" };
    scrollbar-color: ${props => `${props.theme.palette.scrollbar.thumbEnabled} ${props.theme.palette.scrollbar.trackEnabled}`};
    &>* {
        /* Reset in children */
        scrollbar-width: initial;
        scrollbar-color: initial;
    }

    /* Chrome Edge Safari scrollbars */
    @supports selector(::-webkit-scrollbar) {
        /* Use overlay scrollbars to save space */
        overflow-y: ${ alwaysShow ? 'auto' : 'overlay' } !important;
        overflow-x: ${ alwaysShow ? 'auto' : 'overlay' } !important;

        /* Hack to enable transitioning */
        /* Border colors are inherited by scrollbar components */
        border-left-color: ${props => alwaysShow ? 
            props.theme.palette.scrollbar.thumbEnabled :
            props.theme.palette.scrollbar.thumb };
        border-right-color: ${props => alwaysShow ? 
            props.theme.palette.scrollbar.trackEnabled :
            props.theme.palette.scrollbar.track };
        ${props => !alwaysShow && css`
            transition: border ${props => props.theme.transitions.long};
            transition-delay: 500ms;
            :hover {
                transition: border ${props => props.theme.transitions.short};
                border-left-color: ${props.theme.palette.scrollbar.thumbEnabled};
                border-right-color: ${props.theme.palette.scrollbar.trackEnabled};
            }
        `}
    }

    &::-webkit-scrollbar {
        height: ${ size == "large" ? '12px' : '8px' };
        width: ${ size == "large" ? '12px' : '8px' };
        overflow: hidden;
    }

    &::-webkit-scrollbar-corner,
    &::-webkit-scrollbar-button {
        display: block;
        visibility: none;
        height: 4px;
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        border-right-style: inset;
        border-right-color: inherit;
        border-right-width: calc(100vw + 100vh);
        border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb {
        border-left-style: inset;
        border-left-color: inherit;
        border-left-width: calc(100vw + 100vh);
        border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:hover {
        border-left-color: ${props => props.theme.palette.scrollbar.thumbActive};
    }
`;